<div class="dialog-container">
  <h2 mat-dialog-title class="dialog-title">
    {{ 'components.dialogEditKickStats.title' | transloco }}
  </h2>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="kickStatsForm">

      <!-- Yardline de début - Display only -->
      <div class="info-section">
        <div class="info-label">{{ 'components.dialogEditKickStats.startingYardLine' | transloco }}</div>
        <div class="info-value">{{ startingYardLine }}</div>
      </div>

      <!-- Yardlines Section -->
      <div class="form-section">
        <div class="section-header">Yardlines</div>

        <div class="input-row">
          <mat-form-field appearance="outline" class="flex-1">
            <mat-label>{{ 'components.dialogEditKickStats.caughtOn' | transloco }}</mat-label>
            <input
              matInput
              type="number"
              min="-54"
              max="55"
              formControlName="caughtOn"
              (input)="recalculate()"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="flex-1">
              <mat-label>{{ 'components.dialogEditKickStats.endYardLine' | transloco }}</mat-label>
              <input
                matInput
                type="number"
                min="-54"
                max="55"
                formControlName="endYardLine"
                (input)="recalculate()"
                />
              </mat-form-field>
            </div>
          </div>

          <!-- Statistics Section -->
          <div class="form-section">
            <div class="section-header">Statistiques</div>

            <div class="input-row">
              <mat-form-field appearance="outline" class="flex-1">
                <mat-label>{{ 'components.dialogEditKickStats.kickYards' | transloco }}</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="kickYards"
                  />
                  @if (hasValueChanged.kickYardsChanged) {
                    <span class="warning-badge" matSuffix>
                      ⚠ {{ 'components.dialogEditKickStats.originalValue' | transloco }}: {{ data.row.kickYards ?? 0 }}
                    </span>
                  }
                </mat-form-field>

                <mat-form-field appearance="outline" class="flex-1">
                  <mat-label>{{ 'components.dialogEditKickStats.returnYards' | transloco }}</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="returnYards"
                    />
                    @if (hasValueChanged.returnYardsChanged) {
                      <span class="warning-badge" matSuffix>
                        ⚠ {{ 'components.dialogEditKickStats.originalValue' | transloco }}: {{ data.row.returnYards ?? 0 }}
                      </span>
                    }
                  </mat-form-field>
                </div>
              </div>
            </form>
          </mat-dialog-content>

          <mat-dialog-actions align="end" class="dialog-actions">
            <button mat-button mat-dialog-close class="cancel-btn">
              {{ 'components.dialogEditKickStats.annuler' | transloco }}
            </button>
            <button
              mat-flat-button
              color="primary"
              [disabled]="kickStatsForm.invalid"
              (click)="updateKickStats()"
              class="save-btn"
              >
              {{ 'components.dialogEditKickStats.sauvegarder' | transloco }}
            </button>
          </mat-dialog-actions>
        </div>
